import { getStudioPublishDeployCopy } from "@/i18n/studio-publish-deploy-copy";
import type { LocaleCode } from "@/pages/cogo-marketing/i18n/locales";
import type { PublicationReleaseState } from "./publication-release-types";

/**
 * Slice 6 F3 (2026-08-18): this used to be `state.replaceAll("_", " ")` — a
 * machine enum with its underscores rubbed off. Measured producing the
 * IDENTICAL strings on the ko appliance and the en cloud build (`draft`,
 * `verification blocked`, `rolled back`, `taken down`), i.e. a Korean bank
 * operator read the wire vocabulary at the most consequential surface in the
 * product. `locale` is REQUIRED rather than defaulted so a call site that
 * has no locale is a type error here instead of silently English there.
 */
export function publicationStateLabel(
  state: PublicationReleaseState,
  locale: LocaleCode,
): string {
  return getStudioPublishDeployCopy(locale).release.states[state];
}
